import { struct } from 'io-ts/Decoder';

import { Id as FormulaID } from '../../../../whole-house/formula/Id';

export const Params = struct({
	formulaId: FormulaID,
});
